<template>
  <div>
    <Banners mode="firstBanner" />
  </div>
</template>

<script>
import appConfig from '@/app.config'
import Banners from '../../../components/dadban/banners/Banners.vue'

export default {
  page: {
    title: 'مدیریت بنر صفحه اصلی',
    meta: [
      {
        name: 'description',
        content: appConfig.description,
      },
    ],
  },
  name: 'dadban-first-banner',
  components: { Banners },
}
</script>
